<template>
  <div
    class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center"
  >
    <transition
      name="o-transition__fade"
      mode="out-in"
      tag="div"
      class="o-grid__group"
    >
      <div class="o-grid__item" v-if="isEditing" key="close">
        <div
          class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center"
        >
          <div class="o-grid__group">
            <div class="o-grid__item">
              <button
                class="o-button o-button--small"
                @click="save"
                type="button"
              >
                <svg
                  class="o-svg-icon o-button__icon"
                  viewBox="0 0 64 64"
                  type="image/svg+xml"
                >
                  <use
                    xlink:href="spritemap.svg#sprite-check-thinline"
                    x="0"
                    y="0"
                  ></use>
                </svg>
                <span>{{ translationsCustom.save || "" }}</span>
              </button>
            </div>
            <div class="o-grid__item">
              <button
                class="o-button o-button--small o-button--light o-button--shadow"
                @click="cancel"
                type="button"
              >
                <svg
                  class="o-svg-icon o-button__icon"
                  viewBox="0 0 64 64"
                  type="image/svg+xml"
                >
                  <use
                    xlink:href="spritemap.svg#sprite-cross"
                    x="0"
                    y="0"
                  ></use>
                </svg>
                <span>{{ translationsCustom.cancel || "" }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="o-grid__item" v-else key="edit">
        <button
          class="o-button o-button--small o-button--light o-button--shadow"
          @click="edit"
          type="button"
        >
          <svg
            class="o-svg-icon o-button__icon"
            viewBox="0 0 64 64"
            type="image/svg+xml"
          >
            <use xlink:href="spritemap.svg#sprite-edit" x="0" y="0"></use>
          </svg>
          <span>{{ translationsCustom.edit || "" }}</span>
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "c-editControll",
  data() {
    return {
      isEditing: false
    };
  },
  computed: {
    ...mapState("translations", {
      translationsCustom: "custom"
    })
  },
  methods: {
    save() {
      this.isEditing = false;
      this.$emit("save");
    },
    edit() {
      this.isEditing = true;
      this.$emit("edit");
    },
    cancel() {
      this.isEditing = false;
      this.$emit("cancel");
    }
  }
};
</script>

<style lang="scss">
.c-editControll {
}
</style>
